import * as React from "react"

import {BACKEND_APIS} from "@constants"
import {AutocompleteAjaxSeeker} from "@ui-seeker/core";

import {company} from "@signals"


export default function CompanyAutocompleteAjax({ filters = {}, ...props }) {

    return <AutocompleteAjaxSeeker
        multiple
        urlAjax={``}
        filters={{ ...filters }}
        label="Company"
        placeholder="All Companies"
        value={company.value}
        onChange={e => company.value = e.target.value}
        {...props}
    />
}
